import { render, staticRenderFns } from "./growth.vue?vue&type=template&id=f899f214&"
import script from "./growth.js?vue&type=script&lang=js&"
export * from "./growth.js?vue&type=script&lang=js&"
import style0 from "./growth.vue?vue&type=style&index=0&id=f899f214&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports